import { Label } from '../../../schemas';

/**
 * Decode the positioning and size of the label
 * @param label
 * @returns {SIMLabel|Boolean}
 */
export default (label) => {
  if (!label) {
    return false;
  }

  var angle = +label.a || 0;
  var scale = +label.scale || 100;
  var size = +label.size || 50;
  var font = label.font || 'ariale';
  var fontWeight = font === 'arialebold' ? 'bold' : 'normal';

  return new Label({
    id:       label.id,
    text:     label.label.replace(/ /g, '\u00a0').split('\r') || [],
    angle:    angle,
    fontSize: Math.floor(size * (scale / 100)),
    fontWeight: fontWeight,
    position: {
      x: Math.floor(+label.x + 100), // MAGIC NUMBER!!!
      y: Math.floor(+label.y)
    },
    rotationPosition: {
      x: Math.floor(+label.x),
      y: Math.floor(+label.y)
    }
  });
};



// WEBPACK FOOTER //
// ./frontend/react/sim/parser-mnx-geometry/src/decoders/label_decoder.js